import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import Logo from "./logo.js";
import {Cart} from "./icons.js";
import {colors, fontFamily, media} from "./theme.js";
import {t} from "../common/i18n.js";
export default function Header(props) {
  const {sessionCart, locales, locale, url, ...rest} = props;
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Inner, null, /* @__PURE__ */ React.createElement(LogoContainer, {
    small: true
  }), /* @__PURE__ */ React.createElement(Navs, null, /* @__PURE__ */ React.createElement(CartNav, {
    count: sessionCart?.items_count
  }))));
}
function CartNav(props) {
  const {count} = props;
  return /* @__PURE__ */ React.createElement(CartLink, {
    href: "/cart"
  }, /* @__PURE__ */ React.createElement(Cart, null), count && /* @__PURE__ */ React.createElement(CartItemsCount, null, count), /* @__PURE__ */ React.createElement("span", null, t("Warenkorb")));
}
const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  max-width: 100vw;
  display: flex;
  height: 80px;
  z-index: 100;
  isolation: isolate;

  ${media.mobile} {
    left: 0;
  }
`;
const LogoContainer = styled(Logo)``;
const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  position: relative;
  width: 410px;
  margin-left: auto;
  margin-right: 0;
  padding-left: 40px;
  padding-right: 40px;

  background: ${colors.bg};

  ${media.mobile} {
    width: 100%;
    margin-left: 0;
    padding-left: 20px;
    padding-right: 75px;
  }
`;
const Navs = styled.div`
  display: flex;
  align-items: center;
`;
const CartLink = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  line-height: 0;
  font-size: 0;
  font-family: ${fontFamily.secondary};
`;
const CartItemsCount = styled.div`
  position: absolute;
  top: -5px;
  left: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 12px;
  font-family: ${fontFamily.secondary};
  color: ${colors.c};
  border: 1px solid ${colors.c};
  background: ${colors.bg};
`;
const LocaleNav = styled.div`
  display: flex;
  align-items: center;
  margin-left: 12px;
`;
const LocaleLink = styled.a`
  text-transform: uppercase;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  font-family: ${fontFamily.secondary};
  color: ${colors.b4};

  & ~ a {
    margin-left: 12px;
  }

  ${({active}) => active && `
      color: ${colors.b};
    `}
`;
